import React, { Suspense, useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CUSTOMIZER_COMPONENTS } from "../config/customizerRegistry";

export default function KitCustomizerPage({ componentKey }) {
  const location = useLocation();
  const [canRender, setCanRender] = useState(false);
  const CustomizerComponent = CUSTOMIZER_COMPONENTS[componentKey];

  useEffect(() => {
    // Delay rendering to allow the browser to release previous WebGL context
    const timer = setTimeout(() => setCanRender(true), 150);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!CustomizerComponent) return <Navigate to="/" replace />;
  if (!canRender) return <div style={{ padding: "24px" }}>Loading configurator...</div>;

  return (
    <Suspense fallback={<div style={{ padding: "24px" }}>Loading customizer...</div>}>
      <CustomizerComponent key={location.pathname} />
    </Suspense>
  );
}